module.exports = __webpack_public_path__ + "img/services-support-icon.25c72df6.svg";